export default __webpack_public_path__ + "static/media/coins.bae633a8.svg";